import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card } from '../../common';

const StatsCard = ({
  title,
  value,
  icon: Icon,
  trend,
  trendValue,
  subtitle,
  color = 'primary',
  percentage,
}) => {
  const colors = {
    primary: {
      ring: 'bg-primary-50 dark:bg-primary-900/25',
      icon: 'text-primary-600 dark:text-primary-400',
      bar:  'from-primary-400 to-primary-500',
    },
    success: {
      ring: 'bg-emerald-50 dark:bg-emerald-900/25',
      icon: 'text-emerald-600 dark:text-emerald-400',
      bar:  'from-emerald-400 to-emerald-500',
    },
    warning: {
      ring: 'bg-amber-50 dark:bg-amber-900/25',
      icon: 'text-amber-600 dark:text-amber-400',
      bar:  'from-amber-400 to-amber-500',
    },
    danger: {
      ring: 'bg-red-50 dark:bg-red-900/25',
      icon: 'text-red-600 dark:text-red-400',
      bar:  'from-red-400 to-red-500',
    },
    info: {
      ring: 'bg-blue-50 dark:bg-blue-900/25',
      icon: 'text-blue-600 dark:text-blue-400',
      bar:  'from-blue-400 to-blue-500',
    },
    purple: {
      ring: 'bg-purple-50 dark:bg-purple-900/25',
      icon: 'text-purple-600 dark:text-purple-400',
      bar:  'from-purple-400 to-purple-500',
    },
  };

  const c = colors[color] || colors.primary;

  return (
    <Card hoverable className="overflow-hidden">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-2">
            {title}
          </p>
          <p className="text-3xl font-bold text-slate-900 dark:text-slate-50 font-display leading-none mb-1">
            {value}
          </p>

          {trend ? (
            <div className="flex items-center gap-1 mt-2">
              {trend === 'up'
                ? <TrendingUp   className="w-3.5 h-3.5 text-emerald-500" />
                : <TrendingDown className="w-3.5 h-3.5 text-red-500" />
              }
              <span className={`text-xs font-semibold ${trend === 'up' ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'}`}>
                {trendValue}
              </span>
              {subtitle && <span className="text-xs text-slate-400 ml-0.5">{subtitle}</span>}
            </div>
          ) : subtitle ? (
            <p className="text-xs text-slate-400 dark:text-slate-500 mt-1">{subtitle}</p>
          ) : null}
        </div>

        {Icon && (
          <div className={`w-10 h-10 rounded-xl ${c.ring} flex items-center justify-center flex-shrink-0`}>
            <Icon className={`w-5 h-5 ${c.icon}`} />
          </div>
        )}
      </div>

      {percentage !== undefined && (
        <div className="mt-4 h-1 bg-slate-100 dark:bg-slate-700 rounded-full overflow-hidden">
          <div
            className={`h-full bg-gradient-to-r ${c.bar} transition-all duration-700`}
            style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
          />
        </div>
      )}
    </Card>
  );
};

export default StatsCard;
